module.exports = {
  systemAuditObject: {
    uid: '',
    email: '',
    displayName: 'System',
  },
};
